"use strict";
import "@zeitiger/appendaround";
$(() => {
  let $appendableElements = $(".js-append");
  $appendableElements.appendAround();
});
